import { isEmpty, includes, toUpper } from 'lodash';

import * as FILTERS from 'catalog/constants/filter.js';
import ModelModel from 'catalog/models/ModelModel.js';

function resetModelVisibility(model) {
    return model.set('visible', model.get('makeVisible') && model.get('bodyStyleVisible') && model.get('modelVisible'));
}

export function resetModelBodyStylesFilter(model, selectedBodyStyleCodes) {
    return resetModelVisibility(
        model.set(
            'bodyStyleVisible',
            isEmpty(selectedBodyStyleCodes) || includes(selectedBodyStyleCodes, model.get('bodyStyleCode'))
        )
    );
}

export function resetModelMakeFilter(model, make) {
    return resetModelVisibility(
        model.set('makeVisible', !make || make === FILTERS.MAKE_FILTER_ALL || model.get('make') === make)
    );
}

export function resetModelStringFilter(model, modelSearchString) {
    return resetModelVisibility(
        model.set(
            'modelVisible',
            !modelSearchString || includes(toUpper(model.get('model')), toUpper(modelSearchString))
        )
    );
}

// Use HE as bodyStyleCode if HYBRID OR HYBRIDE found from vehicle model and only for HONDA or ACURA make
export function resetModelFromCollectionData(collectionModelData) {
    return new ModelModel({
        make: collectionModelData.getIn(['vehicle', 'make']),
        model: collectionModelData.getIn(['vehicle', 'model']),
        bodyStyleCode:
            (collectionModelData.getIn(['vehicle', 'make']).includes('HONDA') ||
                collectionModelData.getIn(['vehicle', 'make']).includes('ACURA')) &&
            (collectionModelData.getIn(['vehicle', 'model']).includes('HYBRID') ||
                collectionModelData.getIn(['vehicle', 'model']).includes('HYBRIDE'))
                ? 'HE'
                : collectionModelData.getIn(['vehicle', 'bodyStyleCode']),
        bodyStyleCodeOriginal: collectionModelData.getIn(['vehicle', 'bodyStyleCode']),
        bodyStyle: collectionModelData.getIn(['vehicle', 'bodyStyle']),
        exteriorColours: collectionModelData.getIn(['vehicle', 'exteriorColours']),
        exteriorColourStatus: collectionModelData.getIn(['vehicle', 'exteriorColourStatus']),
        purchaseMethods: collectionModelData.get('purchaseMethods'),
        rebate: collectionModelData.getIn(['vehicle', 'rebate']),
        highRebate: collectionModelData.getIn(['vehicle', 'highRebate']),
        highRebatePurchaseMethod: collectionModelData.getIn(['vehicle', 'highRebatePurchaseMethod']),
        financeModelDisclaimer: collectionModelData.getIn(['vehicle', 'financeModelDisclaimer']),
        leaseModelDisclaimer: collectionModelData.getIn(['vehicle', 'leaseModelDisclaimer']),
        priceModelDisclaimer: collectionModelData.getIn(['vehicle', 'priceModelDisclaimer']),
        priceExclusionsDisclaimer: collectionModelData.getIn(['vehicle', 'priceExclusionsDisclaimer']),
        priceYear: collectionModelData.getIn(['vehicle', 'priceIds', 'year']),
        priceModelTrimCode: collectionModelData.getIn(['vehicle', 'priceIds', 'modelTrimCode']),
        priceConfigurationId: collectionModelData.getIn(['vehicle', 'priceIds', 'configurationId']),
        leaseYear: collectionModelData.getIn(['vehicle', 'leaseIds', 'year']),
        leaseModelTrimCode: collectionModelData.getIn(['vehicle', 'leaseIds', 'modelTrimCode']),
        leaseConfigurationId: collectionModelData.getIn(['vehicle', 'leaseIds', 'configurationId']),
        financeYear: collectionModelData.getIn(['vehicle', 'financeIds', 'year']),
        financeModelTrimCode: collectionModelData.getIn(['vehicle', 'financeIds', 'modelTrimCode']),
        financeConfigurationId: collectionModelData.getIn(['vehicle', 'financeIds', 'configurationId']),
    });
}
